export default {
  // define all the getters
  getAccountId: state => {
    return state.accountId;
  },
  getAllUsers: state => {
    return state.allUsers;
  },
  getUserData: state => {
    return {
      name: state.userName,
      email: state.userEmail,
    };
  },
};
